.list {
  width: fit-content;
  background: var(--mantine-color-primary-0);
  border-radius: 0.625rem;
  padding: 0.125rem;

  &::before {
    content: none;
  }
}

.tab {
  padding: 0.75rem 1.5rem;

  border: none;

  &[data-active] {
    background-color: var(--mantine-color-otherWhite-1);
    border-radius: 0.5rem;

    .tabLabel {
      color: var(--mantine-color-primary-7);
      font-weight: 600;
    }
  }

  .tabLabel {
    font-size: 1rem;
    color: var(--mantine-color-tertiary-7);
  }
}
